import type { IResponseApi } from '@/modules/Core/interfaces'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import type { IHeaderCups } from '../interfaces/tablas/IHeaderCups'

export class HeaderCupsService extends BaseService<IHeaderCups> {
  constructor () {
    super({
      baseUrl: 'system/header-cups/'
    })
  }

  /**
   * Sube la imagen de la cabecera
   */
  async postHeader(formData: FormData): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.post<IResponseApi<string>>('/upload-header', formData)
  }

  async deleteImagen (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<number>>> {
    return this.http.delete<IResponseApi<number>>(`/delete-header-image`, {
      params
    })
  }
  async getImagen (
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApi<string>>> {
    return this.http.get<IResponseApi<string>>(`/get-header-image`, { params })
  }
}
